import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Alert, Col, Container, Row } from 'react-bootstrap';
import { get } from 'lodash';
import { Trans, useTranslation } from 'react-i18next';
import { Route, Switch } from "react-router";
import { Redirect, useLocation } from 'react-router-dom';
import { USER } from '../../../utils/constants';
import { INFLUENCERS_ENDPOINTS } from '../../../config/api';
import PhotoGallery from '../../components/PhotoGallery/PhotoGallery';
import useBreakpoint from '../../hooks/useBreakpoint';
import ForgotYourPassword from '../ForgotYourPassword/ForgotYourPassword';
import ResetYourPassword from '../ResetYourPassword/ResetYourPassword';
import SetPassword from '../SetPassword/SetPassword';
import SetProfile from '../SetProfile/SetProfile';
import SignIn from '../SignIn/SignIn';

const CLIENT_PORTAL_URL = 'https://dashboard.obvious.ly/clients/signin';
import signinImg1 from '../../../images/signin/home-1.jpg';
import signinImg2 from '../../../images/signin/home-2.jpg';
import signinImg3 from '../../../images/signin/home-3.jpg';
import signinImg4 from '../../../images/signin/home-4.jpg';
import signinImg5 from '../../../images/signin/home-5.jpg';
import signinImg6 from '../../../images/signin/home-6.jpg';

const SIGNIN_IMAGES = [signinImg1, signinImg2, signinImg3, signinImg4, signinImg5, signinImg6];

/**
 *
 * @param {'influencers'|'agents'|'admins'} user
 * @returns
 */
export default function WelcomePage({
  user = USER.INFLUENCERS
}) {
  const { t } = useTranslation();
  const breakpoint = useBreakpoint();
  const location = useLocation();
  const effectiveUser = location.pathname.startsWith('/team/') ? USER.ADMINS : user;
  const isSetProfile = location.pathname.startsWith('/team/set-profile');
  const [showClientPortalMessage, setShowClientPortalMessage] = useState(false);
  const [showServerError, setShowServerError] = useState(false);
  const [showBanner, setShowBanner] = useState(true);

  useEffect(() => {
    setShowClientPortalMessage(false);
    setShowServerError(false);
    setShowBanner(true);
  }, [location.pathname]);

  useEffect(() => {
    checkForceReloadStatus();
  }, []);

  const checkForceReloadStatus = () => {
    axios.get(INFLUENCERS_ENDPOINTS.FORCE_RELOAD_STATUS)
      .then((response) => {
        if (response.data.reload_page) {
          const influencerForceFrontendReload = response.data.influencer_force_frontend_reload;
          console.log(`previous reloading time: ${localStorage.getItem('influencerForceFrontendReload')}`);
          console.log(`new reloading time: ${influencerForceFrontendReload}`);
          if(localStorage.getItem('influencerForceFrontendReload') != influencerForceFrontendReload) {
            console.log('reloading...');
            localStorage.setItem('influencerForceFrontendReload', response.data.influencer_force_frontend_reload);
            setInterval(window.location.reload(true), 1000);
          }
        }
        else
          console.log('no reload time set');
      })
      .catch((e) => {
        console.log(e);
      });
  };

  return <div id='sign-in-page'>
    {showClientPortalMessage && effectiveUser === USER.ADMINS && (
      <div className="alert alert-danger text-center" role="alert">
        <Trans
          i18nKey="common.pages.sign_in.team_only_message"
          components={[<a key="client-portal-link" href={CLIENT_PORTAL_URL} />]}
        />
      </div>
    )}
    {showServerError && (
      <div className="alert alert-danger" role="alert">
        {t('common.pages.set_password.errors.server_error')}
      </div>
    )}
    {showBanner && get(location, 'state.banner') && (
      <Container>
        <Row>
          <Col xs={12}>
            <Alert
              variant={get(location, 'state.bannerVariant', 'success')}
              onClose={() => setShowBanner(false)}
              dismissible
            >
              {location.state.banner}
            </Alert>
          </Col>
        </Row>
      </Container>
    )}
    <Container>
      <Row>
        {
          breakpoint !== 'xs'
            ?
            <Col xs={12} sm={6}>
              <h1>
                {isSetProfile
                  ? t('common.pages.set_profile.almost_there')
                  : (effectiveUser === USER.ADMINS
                    ? t('common.pages.sign_in.welcome')
                    : t('common.pages.sign_in.welcome_back'))}
              </h1>
              <p>
                {effectiveUser === USER.ADMINS
                  ? t('common.pages.sign_in.good_to_see_you')
                  : t('common.pages.sign_in.we_are_happy')}
              </p>
              <PhotoGallery xs={1} sm={3} lg={3} xl={3} xxl={3} preloadedImages={SIGNIN_IMAGES} />
            </Col>
            : null
        }
        <Col xs={0} sm={1} lg={2} />
        <Col id='sign-in-card' xs={12} sm={5} lg={4}>
          <Switch>
            <Route path={["/signin", "/team/signin"]}>
              <SignIn
                user={effectiveUser}
                onAgentDetected={() => setShowClientPortalMessage(true)}
              />
            </Route>
            <Route path="/team/set-password">
              <SetPassword onServerError={setShowServerError} />
            </Route>
            <Route path="/team/set-profile">
              <SetProfile onServerError={setShowServerError} />
            </Route>
            <Route path={["/forgot-your-password", "/team/forgot-your-password"]}>
              <ForgotYourPassword user={effectiveUser} />
            </Route>
            <Route
              path={[
                "/reset-your-password/:resetPasswordToken",
                "/team/reset-your-password/:resetPasswordToken"
              ]}
              exact
            >
              <ResetYourPassword user={effectiveUser} />
            </Route>
            <Route>
              <Redirect to={effectiveUser === USER.ADMINS ? '/team/signin' : '/signin'} />
            </Route>
          </Switch>
        </Col>
      </Row>
    </Container>
  </div >;
}

WelcomePage.propTypes = {
  user: PropTypes.string,
};
